import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";
export interface AutoStakingState {
	autoStakingSwitchOn: boolean;
	hasError: boolean;
}

const initialState: AutoStakingState | null = null;

@Injectable({
	providedIn: "root"
})
export class AutoStakingStateService extends StateService<AutoStakingState> {
	constructor() {
		super(initialState);
	}

	public updateState(state: Partial<AutoStakingState>): void {
		this.setState(state);
	}

	public getState$(): Observable<AutoStakingState> {
		return this.select((state) => state);
	}

	public hasError(): boolean {
		return this.state?.hasError;
	}

	public isOptedInStateLoaded(): boolean {
		return this.isStateLoaded();
	}
}
